<ion-header class="details-modal-navbar" (click)="dismissModal()">
    <ion-toolbar>
      <ion-title>{{title()?.[translate.currentLang]}}</ion-title>
      <ion-buttons slot="end">
        <ion-icon  name="close"></ion-icon>
      </ion-buttons>
    </ion-toolbar>
</ion-header>